import {
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  Icon,
  InputGroup,
  InputLeftElement,
  Link,
  Text,
} from "@chakra-ui/react";
import {
  AutoComplete,
  AutoCompleteGroup,
  AutoCompleteGroupTitle,
  AutoCompleteInput,
  AutoCompleteItem,
  AutoCompleteList,
} from "@choc-ui/chakra-autocomplete";
import { IconSearch } from "../../styles/icons";
import Image from "next/image";
import StoryblokClient from "storyblok-js-client";
import { useEffect, useRef, useState } from "react";
import debounce from "lodash/debounce";

const Storyblok = new StoryblokClient({
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_KEY,
  region: "eu",
});

const renderSearchResult = (type, result, key) => {
  if (type === "tags") {
    return (
      <Link href={`/article/tags/${result.slug}`} prefetch={false}>
        <AutoCompleteItem
          kkey={key}
          value={result}
          textTransform="capitalize"
          mx="2px"
        >
          <Button variant="outline" color="brand.400" m="0">
            <Text textTransform="capitalize" textStyle="button1">
              {result.displayTag}
            </Text>
          </Button>
        </AutoCompleteItem>
      </Link>
    );
  } else if (type === "authors") {
    return (
      <Link href={`/author/${result.slug}`} prefetch={false}>
        <AutoCompleteItem key={key} value={result} textTransform="capitalize">
          <Flex align="center" gap="10px">
            <Box
              width={{ base: "38px" }}
              height={{ base: "38px" }}
              borderRadius="100%"
              overflow="hidden"
              position="relative"
            >
              <Image
                alt="practitioner photo"
                objectFit="cover"
                layout="fill"
                src={result.image}
                placeholder="blur"
                blurDataURL="data:image/jpeg;base64,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"
              />
            </Box>
            <Text textTransform="capitalize" textStyle="button1">
              {result.name}
            </Text>
          </Flex>
        </AutoCompleteItem>
      </Link>
    );
  } else {
    return (
      <Link href={`/article/${result.slug}`} prefetch={false}>
        <AutoCompleteItem key={key} value={result} textTransform="capitalize">
          <Text textTransform="capitalize">{result.title}</Text>
        </AutoCompleteItem>
      </Link>
    );
  }
};

const ArticleSearchInput = ({}) => {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState({
    authors: [],
    articles: [],
    tags: [],
  });

  const inputRef = useRef();

  const debouncedSearch = useRef(
    debounce(async (criteria) => {
      const tagMap = {};
      const datasourceEntries = await Storyblok.getAll(
        `cdn/datasource_entries`,
        {
          datasource: "articletagmap",
        }
      );
      datasourceEntries.forEach((tag) => {
        tagMap[tag.name] = tag.value;
      });
      const {
        data: { stories: articles },
      } = await Storyblok.get(`cdn/stories`, {
        starts_with: "article",
        version: "published",
        search_term: criteria,
      });
      const {
        data: { stories: authors },
      } = await Storyblok.get(`cdn/stories`, {
        starts_with: "authors",
        version: "published",
        search_term: criteria,
      });
      const {
        data: { tags },
      } = await Storyblok.get(`cdn/tags`, {
        starts_with: "article",
      });
      setLoading(false);
      const newResults = { ...results };
      newResults.articles = articles.map((article) => ({
        title: article.name,
        slug: article.slug,
      }));
      newResults.authors = authors.map((author) => ({
        name: author.name,
        slug: author.slug,
        image: author.content.image.filename,
      }));
      newResults.tags = tags
        .map((tag) => {
          if (tagMap[tag.name]) {
            return { ...tag, slug: tag.name, name: tagMap[tag.name] };
          } else {
            return { ...tag, slug: tag.name, name: tag.name };
          }
        })
        .map((tag) => ({
          displayTag: tag.name,
          slug: tag.slug,
        }));
      setResults(newResults);
    }, 300)
  ).current;

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  async function inputChange(e) {
    setLoading(true);
    debouncedSearch(e.target.value);
  }

  return (
    <FormControl>
      <AutoComplete isLoading={loading}>
        <InputGroup flex={1} h="54px">
          <InputLeftElement pointerEvents="none" height="45px" ml="5px">
            <Icon as={IconSearch} boxSize="8" color="brand.300" />
          </InputLeftElement>
          <AutoCompleteInput
            variant="outline"
            ref={inputRef}
            placeholder="Search for tags, articles, and authors"
            _placeholder={{
              base: { fontSize: "14px" },
              md: { fontSize: "16px" },
            }}
            size="lg"
            borderRadius="30px"
            borderWidth={1}
            borderColor="brand.300"
            maxW="425px"
            w="100%"
            h="42px"
            onChange={inputChange}
          />
        </InputGroup>
        <AutoCompleteList
          py="20px"
          px="10px"
          borderRadius="20px"
          sx={{
            "::-webkit-scrollbar": {
              width: "4px",
            },
            "::-webkit-scrollbar-track": {
              width: "6px",
            },
            "::-webkit-scrollbar-thumb": {
              background: "brand.400",
              borderRadius: "24px",
            },
          }}
        >
          {Object.entries(results).map(([type, results], co_id) => (
            <AutoCompleteGroup key={co_id} showDivider={false}>
              <AutoCompleteGroupTitle
                textTransform="capitalize"
                ml="15px"
                direction="column"
              >
                <Flex
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Text textStyle="searchSectionTitle">{type}</Text>
                  {type === "articles" && (
                    <Link
                      prefetch={false}
                      href={`/article/search?criteria=${inputRef.current?.value}`}
                    >
                      <Button color="brand.400" m="0">
                        <Text
                          textTransform="capitalize"
                          color="white"
                          textStyle="button1"
                        >
                          See all
                        </Text>
                      </Button>
                    </Link>
                  )}
                </Flex>
                <Divider borderWidth="1px" mt="10px" />
              </AutoCompleteGroupTitle>
              <Flex
                direction={type === "tags" ? "row" : "column"}
                flexWrap="wrap"
              >
                {results.map((result, c_id) =>
                  renderSearchResult(type, result, c_id)
                )}
              </Flex>
            </AutoCompleteGroup>
          ))}
        </AutoCompleteList>
      </AutoComplete>
    </FormControl>
  );
};

export default ArticleSearchInput;
